import { getApiErrorMessages } from '@common/helpers/handleApiErrors';

export default function getRequestError(err: unknown, fallback: string) {
	const status = (err as { response?: { status?: number } })?.response?.status;
	const message = getApiErrorMessages(err).join(' ');
	return status >= 500 || /SQLSTATE\[|Stack trace:|Exception:/i.test(message)
		? fallback
		: message || fallback;
}
